<template>
    <div class="white elevation-2">
        <v-toolbar id="v-toolbar" flat dense >
            <v-toolbar-title id="title"> {{title}} </v-toolbar-title>
            <slot name="action">

            </slot>
        </v-toolbar> 
        <div class="pl-4 pr-4 pt-2 pb-2">
            <slot>
                No slot content defined.
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props:[
        'title'
    ]
}
</script>

<style scooped>
#v-toolbar {
    background: #548FD0;
    background-color: #548FD0;
}
#title {
    color: white;
}
</style>
